<nav aria-label="Page navigation">
  <div class="pagination">
    <div class="page-item prev-next" [class.disabled]="currentPage === 1">
      <button class="page-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
    </div>

    <div class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
      <button class="page-link" (click)="changePage(page)">{{ page }}</button>
    </div>

    <div class="page-item prev-next" [class.disabled]="currentPage === totalPages">
      <button class="page-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">Next
      </button>
    </div>
  </div>
</nav>
  